import { Autoplay } from "swiper/js/swiper.esm";

export default {
    productsSlider: {
        slidesPerView: 'auto',
        watchOverflow: true
    },
    newsSlider: {
        slidesPerView: 'auto',
        watchOverflow: true,
        navigation: 'default'
    },
    clientsSlider: {
        slidesPerView: 1,
        pagination: 'default',
        lazy: true
    },
    prodImage: {
        effect: 'fade',
        lazy: true,
        slidesPerView: 1,
        watchOverflow: true,
        preloadImages: false,
        thumbs: {
            swiper: {
                el: '#prodThumbs',
                freeMode: true,
                slidesPerView: 'auto',
                watchOverflow: true
            },
            multipleActiveThumbs: false
        }
    },
    filterSlider: {
        freeMode: true,
        slidesPerView: 'auto',
        loop: false,
        watchOverflow: true
    }
};